module.exports = __webpack_public_path__ + "img/carrousel-rad-digi-sala-6.630a24ce.png";